const API_PATH = '/tops-offline-api/api/v1';
const LOCAL_API_ORIGIN = 'http://localhost:8080';

export function resolveBackendApiBaseUrl(): string {
  const origin = globalThis.location?.origin || '';
  const hostname = globalThis.location?.hostname || '';
  const protocol = globalThis.location?.protocol || '';

  if (hostname === 'localhost' || hostname === '127.0.0.1' || protocol === 'tops-offline:') {
    return `${LOCAL_API_ORIGIN}${API_PATH}`;
  }

  return `${origin}${API_PATH}`;
}